import { BankOutlined } from '@ant-design/icons';
import { FeatureFlag } from '@sonar-software/sonar-core';
import React from 'react';
import { COPY_SPECIFIC, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
export const governanceSubMenu = {
    children: [
        {
            feature: FeatureFlag.DataDictionary,
            id: 'data-dictionary-menu-item',
            key: FULL_ROUTES.DATA_DICTIONARY,
            label: COPY_SPECIFIC.DATA_DICTIONARY,
            route: FULL_ROUTES.DATA_DICTIONARY
        }
    ],
    icon: React.createElement(BankOutlined, null),
    id: 'governance-submenu',
    key: 'governance',
    label: COPY_SPECIFIC.DATA_GOVERNANCE
};
